import { render, staticRenderFns } from "./personalInfoFormNew.vue?vue&type=template&id=6a2eb904&scoped=true"
import script from "./personalInfoFormNew.vue?vue&type=script&lang=js"
export * from "./personalInfoFormNew.vue?vue&type=script&lang=js"
import style0 from "./personalInfoFormNew.vue?vue&type=style&index=0&id=6a2eb904&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2eb904",
  null
  
)

export default component.exports